import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const TooltipStyled = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.tooltip.background,
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(12),
  },
}))(Tooltip);

export default TooltipStyled;
